export const baseURL = "";
// Use the local server when in development
// export const baseURL = "http://localhost:3001"
